import { render } from "./CentraliRead.vue?vue&type=template&id=f585b89e"
import script from "./CentraliRead.vue?vue&type=script&lang=js"
export * from "./CentraliRead.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__